import React from "react";
import BaseSlide from "./BaseSlide";
import useFitText from "use-fit-text";

export default ({ title, splitDirection = "right", children, image }) => {
  const { fontSize, ref } = useFitText();

  // if split left, just reverse the flex-direction
  return (
    <BaseSlide title={title}>
      <div
        className={`flex h-full items-center ${
          splitDirection === "left" ? "flex-col-reverse" : ""
        }`}
      >
        <div ref={ref} style={{ fontSize, height: "60vh", width: "45vw" }}>
          <div className="flex justify-center items-center h-full">
            {children}
          </div>
        </div>
      </div>
      <div
        className="flex justify-center items-center h-full"
        style={{ width: "45vw", height: "60vh" }}
      >
        <img src={image} style={{ maxWidth: "100%", maxHeight: "100%" }} />
      </div>
    </BaseSlide>
  );
};
